import React from 'react';
import PollAnswerBlock from '../PollAnswerBlock/PollAnswerBlock';
import { DESCRIPTION_LABEL, POLL_QUESTION_TYPE_LABELS } from '../../constants/polls.constant';

const PollsResults = ({ polls = [] }) => {
  return (
    <div className="vve-polls-results">
      {polls.map((poll, pollIndex) => (
        <React.Fragment key={pollIndex}>
          <div className="vve-poll-block">
            <div className="vve-poll-header">
              <span className="vve-poll-title">{poll?.title}</span>
              <br />
              <span className="vve-poll-description">{DESCRIPTION_LABEL}</span>
            </div>
            <div className="vve-poll-questions">
              {poll.questions.map((q, qIndex) => {
                const rightAns = q?.rightAnswers || [];
                const quesType = q?.type;
                return (
                  <div key={qIndex} className="vve-poll-question-wrapper">
                    <div className={`vve-poll-question-block ${qIndex % 2 === 1 ? 'vve-poll-question-block-shaded' : ''}`}>
                      <div className="vve-poll-question-text">
                        <span className="vve-poll-question-number">{qIndex + 1}.</span>
                        {q.question} <span className="vve-poll-question-type">({POLL_QUESTION_TYPE_LABELS[q.type] || q.type})</span>
                      </div>
                      <div className="vve-poll-options">
                        {q.answers.map((ans, ansIndex) => (
                          <PollAnswerBlock key={ansIndex} ans={ans} rightAns={rightAns} questionType={quesType} />
                        ))}
                      </div>
                    </div>
                    <hr className="vve-question-divider" />
                  </div>
                );
              })}
            </div>
          </div>
          {pollIndex < polls.length - 1 && (
            <React.Fragment>
              <hr className="vve-divider vve-divider-top-polls" />
              <hr className="vve-divider vve-divider-bottom" />
            </React.Fragment>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default PollsResults;
